let flickFix = {};

flickFix.init = () => {
  // IOS 13.1.3 Flickity Fix
  let touchingCarousel = false;
  let touchStartCoords;

  let eleFlick = document.getElementsByClassName('flickity-slider');
  for (let i = 0; i < eleFlick.length; i++) {
    eleFlick[i].addEventListener('touchstart', function (e) {
      if (e.type == "touchstart") {
        touchingCarousel = true;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY,
      }
    });

    eleFlick[i].addEventListener('touchend', function (e) {
      if (e.type == "touchend") {
        touchingCarousel = false;
      }
    });

    eleFlick[i].addEventListener('touchmove', function (e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y,
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {
      passive: false,
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  flickFix.init();
});



// WEBPACK FOOTER //
// ./scripts/components/flickFix.js